import { AsyncStoreItem } from '@lib/store';
import { CreateSkLkrlResponse } from 'src/sdk-servicing';

/**
 * CreateSkLkrl model
 */
export interface CreateSkLkrlModel {
  model: CreateSkLkrlResponse | null;
}

/**
 * CreateSkLkrlResponse model details
 */
export interface CreateSkLkrlStateDetails extends AsyncStoreItem {}

/**
 * CreateSkLkrl store state
 */
export interface CreateSkLkrlState extends CreateSkLkrlStateDetails, CreateSkLkrlModel {}

/**
 * Name of the CreateSkLkrl Store
 */
export const CREATE_SK_LKRL_STORE_NAME = 'createSkLkrl';

/**
 * CreateSkLkrl Store Interface
 */
export interface CreateSkLkrlStore {
  /** CreateSkLkrl state */
  [CREATE_SK_LKRL_STORE_NAME]: CreateSkLkrlState;
}
